export default class AdminAuscultations {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.adminAuscultationsRoute, {
      params
    })
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminAuscultationsRoute}/${id}`, {})
  }

  export(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminAuscultationsRoute}/export/all`, {
      params,
      responseType: "blob"
    })
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminAuscultationsRoute}`, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminAuscultationsRoute}/${id}`, payload, {})
  }

  upload(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminAuscultationsRoute}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.adminAuscultationsRoute}/${id}`, {})
  }
}
